import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosInstance, { weburl } from '../../../axiosInstance';
import Swal from 'sweetalert2'; // Import SweetAlert2
import withReactContent from 'sweetalert2-react-content'; // Import React components for SweetAlert2

import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import LoadingTable from '../../components/LoadingTable';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import toast from "react-hot-toast";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; 
import "react-date-range/dist/theme/default.css"; 

// import DatePicker from "react-datepicker";

// import "react-datepicker/dist/react-datepicker.css";

const MySwal = withReactContent(Swal); // Create a SweetAlert2 instance with React components


function AllReport() {

        const [searchQuery, setSearchQuery] = useState("");
        
          const handleInputChange = (e) => {
            setSearchQuery(e.target.value);
          };


          const handleClearClick = () => {
            setSearchQuery("");
          };

            const [AllProducts, setAllProducts] = useState([]);
            const [ProductId, setProductId] = useState({});

            const getUserAllPro = async () => {
              try {
                  const response = await axiosInstance.get(`/all-products/`);
          
                  setAllProducts(response.data.products);
                  console.log('setAllProducts', response.data.products)
          
              } catch (error) {
                  console.error('Error fetching user products:', error);
              } 
          };
          
          const handleClickProduct = (product) => {
            setProductId(
              {
                name: product.title,
                id:  product._id,
              }
            );
             setSearchQuery("");
          }

  const [showSearch, setShowSearch] = useState("false");
  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };

  const filteredProducts = AllProducts.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  );


  const [Dateinputs, setDateinputs] = useState({
    startDate: null, // Use null or a default Date object
    endDate: null, // Use null or a default Date object
  });

  const handleStartDateChange = (ranges) => {
    setDateinputs((prevState) => ({
      ...prevState,
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate,
    }));
  };

  const handleDateFilter = () => {
    SetDateFilter(true);
    setCurrentPage(1);
  };
  
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setlimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');

  const [DateFilter, SetDateFilter] = useState(false);





  const [formData, setFormData] = useState({
    status: "",
  });

  const handleClearFilter = () => {
    SetDateFilter(true);
    setProductId({});
    setCurrentPage(1);
    setFormData((prevData) => ({
      ...prevData,
      status: '',
    }));
    setDateinputs((prevState) => ({
      ...prevState,
      startDate: null,
      endDate: null,
    }));
   };



  const fetchData = async () => {

    const startDate = Dateinputs.startDate
    ? Dateinputs.startDate.toISOString()
    : "";
  const endDate = Dateinputs.endDate
    ? Dateinputs.endDate.toISOString()
    : "";
 
  
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/admin/all-order?page=${currentPage}&limit=${limit}&search=${searchTerm}&startDate=${startDate}&endDate=${endDate}&status=${formData.status}&productId=${ProductId && ProductId.id ? ProductId.id :''}`);
         setData(response.data.Order || []);
      setCurrentPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
      console.log(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
      setData([]);
    } finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, limit, formData.status,ProductId,Dateinputs.startDate && Dateinputs.endDate]);
  useEffect(() => {
  getUserAllPro();
}, []);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const [MyOrderId, setMyOrderId] = useState(null);

  // Function to handle delete
  const handleDelete = (categoryId) => {
    MySwal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true,
      customClass: {
        popup: 'custom-swal-popup', // Add a class to the entire dialog
        confirmButton: 'btn-danger', // Add a class to the confirm button
      },
    }).then((result) => {
      if (result.isConfirmed) {


        axiosInstance.delete(`/admin/delete-order/${categoryId}`)
          .then(() => {
            // Refresh the data or update the state after successful deletion
            fetchData();
            toast.success("Deleting Order success!");
          })
          .catch((error) => {
            console.error('Error deleting data:', error);
            toast.error("Error deleting data");
          });
      }
    });
  };

  const handleEditOrder = (orderId) => {
    setMyOrderId(orderId);
  }

  const handleStatusChange = (ratingId) => async (event) => {
    const newStatus = event.target.value;
    setLoading(true);

    try {
      await axiosInstance.put(`/admin/update-order/${ratingId}`, { status: newStatus });
      setLoading(false);
      fetchData(currentPage);
      toast.success("Status Updated success!");
    } catch (error) {
      console.error('Error updating rating status:', error);
      setLoading(false);
    }

  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));

  };


  const inputRef = React.createRef();

  const handleSearchInputChange = (e) => {
    setCurrentPage(1);
    setTotalPages(1);
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    fetchData(currentPage);
  };


  function formatDate(isoDate) {
    const date = new Date(isoDate);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  }


  const downloadInvoice = async (id) => {
    try {
       const response = 
           await toast.promise(
               axiosInstance.post(
                   `/admin/download-invoice`, { invoiceId : id},
                   { responseType: 'blob' }
               ),
               {
                   loading: 'Invoice Downloading...',
                   success: 'Invoice Downloaded!',
                   error: 'Failed to Download Invoice.'
               }
           );

       // await axiosInstance.get(`/admin/export/alltrans/`, { responseType: 'blob' });
       const url = window.URL.createObjectURL(new Blob([response.data]));
       const link = document.createElement('a');
       link.href = url;
       link.setAttribute('download', 'invoice.pdf');
       document.body.appendChild(link);
       link.click();
       link.parentNode.removeChild(link);
   } catch (error) {
       console.error('Error exporting data:', error);
       toast.error('Error exporting data:', error);
   }

};
 
const formatdays = (Pickup,Return) => {
     const pickupDate = new Date(Pickup);
    const returnDate = new Date(Return);
    const diffTime = returnDate - pickupDate;
    const diffDays = diffTime / (1000 * 3600 * 24);
   return diffDays;
    }

  return (
    <>
      <Sidebar />
      <main className="content" style={{minHeight:'100vh'}}>
        <Navbar />
        <div className="py-4">


          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="mb-3 mb-lg-0">
              <h1 className="h4"> All Report</h1>
            </div>

            <div className="dropdown">
                  <button
                    type="button"
                    className="btn btn-primary btn-sm dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="false"
                    aria-expanded="false"
                  >
                    <i className="ri-filter-2-fill me-2"></i> Filter
                  </button>
<br/>
                  {FormData.status && FormData.status !== "" && (
                    <span className="d-inline-block border-right  p-2  ">
                      <label className="d-inline-block fw-bold">
                        Filters By Status
                      </label>{" "}
                      <br />
                      <div
                        className="d-inline-block badge rounded-pill bg-dark px-2 py-2 "
                        type="button"
                        onClick={handleClearFilter}
                      >
                        <i className="ri-close-line bg-white p-1 rounded-xl me-1 text-dark"></i>
                        {formData.status === "0" && "Processing"}
                        {formData.status === "1" && "Assigned"}
                        {formData.status === "2" && "Delivered to client"}
                        {formData.status === "3" && "Return to runner"}
                        {formData.status === "4" && "Received in store"}
                        {formData.status === "5" && "Cancel Order"}
                       </div>
                    </span>
                  )}
                  {(Dateinputs.startDate && Dateinputs.endDate || ProductId || formData.status) &&   <div
                        className="d-inline-block badge rounded-pill bg-danger px-2 py-2 my-3"
                        type="button"
                        onClick={handleClearFilter}
                      >
                        <i className="ri-close-line bg-white p-1 rounded-circle me-1 text-danger"></i>
                        Clear Filter
                      </div>
                       }
{/* 
                  {Dateinputs.startDate && Dateinputs.endDate && (
                    <span className="d-inline-block  p-2  border-right">
                      <label className="d-inline-block fw-bold">
                        {" "}
                        Start Date
                      </label>{" "}
                      <br />
                      <div
                        className="d-inline-block badge rounded-pill bg-dark px-2 py-2 "
                        type="button"
                        onClick={handleClearFilter}
                      >
                        <i className="ri-close-line bg-white p-1 rounded-circle me-1 text-dark"></i>
                        {formatDate(Dateinputs.startDate.toISOString())}
                      </div>
                    </span>
                  )}

                  {Dateinputs.startDate && Dateinputs.endDate && (
                    <span className="d-inline-block  p-2">
                      <label className="d-inline-block fw-bold">End Date</label>{" "}
                      <br />
                      <div
                        className="d-inline-block badge rounded-pill bg-dark px-2 py-2 "
                        type="button"
                        onClick={handleClearFilter}
                      >
                        <i className="ri-close-line bg-white p-1 rounded-circle me-1 text-dark"></i>
                        {formatDate(Dateinputs.endDate.toISOString())}
                      </div>
                    </span>
                  )} */}

                  <div
                    className="dropdown-menu border rounded-md p-4  table-flow overflow-auto "
                    style={{ zIndex: "99" }}
                  >
                    <b className="d-block fw-bold mb-2"> Filters By Status</b>

                    <label
                      className={`btn btn-sm me-3 ${
                        formData.status && formData.status === "0"
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      type="button"
                      htmlFor="status0"
                    >
                      <input
                        className="form-check-input d-none"
                        type="radio"
                        name="status"
                        id="status0"
                        value={0}
                        onChange={handleChange}
                      />
                      Processing
                    </label>

                    <label
                      className={`btn btn-sm me-3 ${
                        formData.status && formData.status === "1"
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      type="button"
                      htmlFor="status1"
                    >
                      <input
                        className="form-check-input d-none"
                        type="radio"
                        name="status"
                        id="status1"
                        value={1}
                        onChange={handleChange}
                      />
                      Assigned
                    </label>

                    <label
                      className={`btn btn-sm me-3 ${
                        formData.status && formData.status === "2"
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      type="button"
                      htmlFor="status2"
                    >
                      <input
                        className="form-check-input d-none"
                        type="radio"
                        name="status"
                        id="status2"
                        value={2}
                        onChange={handleChange}
                      />
                      Delivered to client
                    </label>

                    <label
                      className={`btn btn-sm me-3 ${
                        formData.status && formData.status === "3"
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      type="button"
                      htmlFor="status3"
                    >
                      <input
                        className="form-check-input d-none"
                        type="radio"
                        name="status"
                        id="status3"
                        value={3}
                        onChange={handleChange}
                      />
                      Return to runner
                    </label>


                    <label
                      className={`btn btn-sm me-3 ${
                        formData.status && formData.status === "4"
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      type="button"
                      htmlFor="status4"
                    >
                      <input
                        className="form-check-input d-none"
                        type="radio"
                        name="status"
                        id="status4"
                        value={4}
                        onChange={handleChange}
                      />
                      Received in store
                    </label>


                    <label
                      className={`btn btn-sm me-3 ${
                        formData.status && formData.status === "5"
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      type="button"
                      htmlFor="status5"
                    >
                      <input
                        className="form-check-input d-none"
                        type="radio"
                        name="status"
                        id="status5"
                        value={5}
                        onChange={handleChange}
                      />
                     Cancel Order
                    </label>


                    <hr />

                    <b className="d-block fw-bold"> Filters By Date </b>

             

                    <DateRangePicker
                      className=" my-3 w-auto "
                      onChange={handleStartDateChange}
                      showSelectionPreview={true}
                      moveRangeOnFirstSelection={false}
                      ranges={[
                        {
                          startDate: Dateinputs.startDate,
                          endDate: Dateinputs.endDate,
                          key: "selection",
                        },
                      ]}
                    />

                    <div className="d-flex text-right justify-content-between align-items-center">
                      {(FormData.status ||
                        (Dateinputs.startDate && Dateinputs.endDate)) && (
                        <>
                          <button
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseExample"
                            aria-expanded="true"
                            aria-controls="collapseExample"
                            onClick={handleClearFilter}
                            className=" btn btn-sm btn-danger text-white me-4"
                          >
                            <i className="ri-delete-bin-5-fill me-2"></i> Clear
                          </button>
                          <button
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseExample"
                            aria-expanded="true"
                            aria-controls="collapseExample"
                            onClick={handleDateFilter}
                            className="ms-auto btn btn-sm btn-secondary bg-dark text-white "
                          >
                            <i className="ri-filter-3-fill me-2"></i> Apply
                          </button>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="bg-fix" />
                </div>


<div className='col-md-12'>
  {ProductId && ProductId.name && 
    <p className='bg-warning px-2 text-white w-auto d-inline-block mb-2 rounded'> Filter Product :   {ProductId.name} </p>
  }
  
            {/* Search */}
                <div
                  className={`input-group d-flex me-5 w-500 searchbox flex-fill ${!showSearch && "search-view"
                    } `}
                  style={{ backgroundColor: "#f3f7fb" }}
                >
                  <input
                    id="searchInput"
                    className="form-control searchinput"
                    type="text"
                    placeholder="Search for user"
                    value={searchQuery}
                    onChange={handleInputChange}
                  />
                  <button
                    type="button"
                    className="btn btn-primary bg-gradient d-none d-lg-block search  text-secondary"
                  >
                    <i className="ri-search-line fw-bold" />
                  </button>

           
                  {searchQuery && (
                    <>
                      <button
                        type="button"
                        className="btn btn-primary bg-gradient d-none d-lg-block close"
                        onClick={handleClearClick}
                      >
                        {" "}
                        <i class="navbar-actions-icon ri-close-line fs-7"></i>{" "}
                      </button>
                    </>
                  )}
                </div>

                {searchQuery && (
                    <>
                      <ul class="searchfloat mt-3 p-0">
                        {searchQuery &&
                          filteredProducts &&
                          filteredProducts.map((item) => {
                            console.log("item.slug", item.slug);
                            const myslug =  item._id; // Make sure `data` and `Product` are defined and available in the scope.
                            return (
                              <li key={item.id} className='d-block'>
                                <Link 
                                  onClick={()=> handleClickProduct(item)}
                                > 
                                  <i class="ri-shopping-bag-line"></i>{" "}
                                  {item.title} {(item.stock || item.stock === 0 )&& <> |  <span class="badge bg-warning font-small px-2 py-1 text-white-800 ms-1 fw-bold"> {item.stock} available</span> </>} <span> </span>
                                </Link>
                              </li>
                            );
                          })}
                      
                      </ul>
                    </>
                  )}


                {/* Search */}

</div>



          </div>
        </div>

        <div
  className="modal fade w-100"
  id="modal-edit"
  tabIndex={-1}
  aria-labelledby="modal-rental"
  style={{ display: "none" }}
  aria-hidden="true"
>
  <div className="modal-dialog modal-dialog-centered" role="document" style={{maxWidth:1200}}>
  
    <div className="modal-content">

    <div class="modal-header">
        <h5 class="modal-title">Edit Order</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div className="modal-body" >
        <iframe src={`/edit-order/${MyOrderId}`} className='w-100' style={{minHeight:'80vh'}}/>
      </div>
      
    </div>
  </div>
</div>



        <div className="card">
          <div className="table-responsive py-4">

            {loading ? (
              <LoadingTable />
            ) : (
              <>


                <div className="datatable-top">
                  <div className="datatable-dropdown">
                    <label>
                      <select className="datatable-selector" value={limit} onChange={(e) => {
                        setlimit(parseInt(e.target.value, 10));
                        setCurrentPage(1); // Reset current page to 1 when the limit changes
                      }} >
                        <option value={5}>5</option>
                        <option value={10} >
                          10
                        </option>
                        <option value={15}>15</option>
                        <option value={20}>20</option>
                        <option value={25}>25</option>
                      </select>{" "}

                      entries per page
                    </label>
                  </div>

                  {/* <div className="datatable-dropdown">
                    <label>
                      Filter Status
                      <select className="datatable-selector mx-2" name="status" onChange={handleChange} value={formData.status}
                      >
                        <option value=" ">All Status</option>
                        <option value="0">Cancel</option>
                        <option value="1">Placed</option>
                        <option value="2">Accepted</option>
                        <option value="3">Packed</option>
                        <option value="4">Shipped</option>
                        <option value="5">Delivered</option>
                      </select>{" "}


                    </label>
                  </div> */}


                  <div className="d-flex align-items-center gap-2">
                    <div className="datatable-search">
                      <input
                        className="datatable-input"
                        type="text"
                        placeholder="Search...(By Order ID)" value={searchTerm}
                        onChange={handleSearchInputChange}
                      />
                    </div>
                    <button className="btn btn-primary" onClick={handleSearch}> Search
                    </button>

                  </div>
                </div>



                <table className="table table-flush">
                  <thead>
                    <tr>
                      <th>Order ID</th>
                      <th>Product</th>

                      <th> Client </th>
                      <th> Duration </th>
                      <th> Status</th>
                      <th> Revenue </th>
                      <th>Action</th>

                    </tr>
                  </thead>
                  <tbody>
                    {data.length !== 0 && data.map((row) => (
                      <tr key={row._id}>

                        <td style={{ maxWidth: 50 }} >
                          {row.orderId}
                          </td>

                          <td style={{ maxWidth: 250 }} >
                       
                          {row.addProduct.length > 0 ? (
    row.addProduct.map((product, index) => (
      <p key={product.id || index} style={{whiteSpace:'normal'}}>
     {index+1} | {product.title}  
         
      </p>
    ))
  ) : (
    <p>
       No products added 
    </p>
  )}

                          </td>

                        <td> 
                          <div style={{ whiteSpace: "break-spaces", maxWidth: 200 }} >
                          <b>Name:</b> {row.userId?.username} <br />
                          <b>Email:</b> {row.userId?.email} <br />
                          <b>Phone:</b> {row.userId?.phone} <br />
                         </div></td>
                    
 
                         <td> 
                         {formatdays(row.PickupDate, row.ReturnDate)} Days
                         </td>

                         <td> 
                         
                         <span className={`badge bg-${
    row.status === 0 ? 'secondary' :
    row.status === 1 ? 'primary' :
    row.status === 2 ? 'success' :
    row.status === 3 ? 'warning' :
    row.status === 4 ? 'info' :
    row.status === 5 ? 'danger' : 'dark'
  }`}>
    {
      row.status === 0 ? 'Processing' :
      row.status === 1 ? 'Assigned' :
      row.status === 2 ? 'Delivered to client' :
      row.status === 3 ? 'Return to runner' :
      row.status === 4 ? 'Received in store' :
      row.status === 5 ? 'Cancel Order' :
      'Unknown'
    }
  </span>

  </td>

                         
                          <td>
  <div style={{ whiteSpace: "break-spaces", maxWidth: 200 }}>
    ₹{Math.round(row.totalAmount)}
  </div>
</td>


                        <td>

{/* 
                          <select style={{ width: "fit-content" }} className={`form-control select`} value={row.status} name="status" onChange={handleStatusChange(row._id)}>
                            <option value="0">Processing</option>
                            <option value="1">Assigned</option>
                            <option value="2">Delivered to client</option>
                            <option value="3">Return to runner</option>
                            <option value="4">Received in store</option>
                            <option value="5">Cancel Order</option>

                           </select>
                           <br />
                          <button
                            className="btn btn-primary"
                            data-bs-toggle="modal" data-bs-target="#modal-edit"
                            onClick={()=> handleEditOrder(row._id)}
                           >
                            Edit
                          </button>
                          <br />
                          <button
                            className="btn btn-danger mt-2"
                            onClick={() => handleDelete(row._id)}
                          >
                            Delete
                          </button>
          */}

<a
                                className="back-btn btn-sm bg-dark m-0 rounded text-white btn-sm ms-1 mt-2"
                                href={`${weburl}user-invoice/${row._id}`} target='blank'
                                >
                                Invoice
                              </a>



                        </td>

                        
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="datatable-bottom">
                  <div className="datatable-info">  </div>
                  <nav className="datatable-pagination">
                    <ul class="datatable-pagination-list">

                      <li className={`datatable-pagination-list-item ${currentPage === 1 ? 'datatable-hidden' : 'datatable-active'}`}>
                        <button data-page="1" class="datatable-pagination-list-item-link" onClick={handlePreviousPage} disabled={loading || currentPage === 1}
                          aria-label="Page 1">‹</button>
                      </li>
                      <li>
                        <div className="datatable-info py-1 px-3">Showing  Page{' '}
                          <strong>
                            Showing Page  {currentPage} of {totalPages}

                          </strong>{' '} </div>
                      </li>
                      <li className={`datatable-pagination-list-item ${currentPage === totalPages ? 'datatable-hidden' : 'datatable-active'}`}>
                        <button data-page="2" class="datatable-pagination-list-item-link" aria-label="Page 2" onClick={handleNextPage} disabled={loading || currentPage === totalPages}
                        >  {loading ? 'Loading...' : '›'} </button>
                      </li>
                    </ul></nav>
                </div>



              </>
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default AllReport;
